import React from "react";
import { Box } from "@mui/material";

export const Error404 = () => {
  return <Box>404</Box>;
};
